import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  AllUsersQueuesComponent,
  SingleUserQueuesComponent
 } from '.';
import { RouterModule, Routes } from '@angular/router';
import { TodaysMessagesComponent } from './todays-messages/todays-messages.component';

const routes: Routes = [
  {
    path: '',
    component: AllUsersQueuesComponent, data: {title: 'All Queues'}
  },
  {
    path: 'todays',
    component: TodaysMessagesComponent, data: {title: `Today's Messages`}
  },
  {
    path: ':id',
    component: SingleUserQueuesComponent, data: {title: 'User Queue'}
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
})
export class AllQueuesRoutingModule { }
